import { connect } from 'react-redux'
import { actions, selectors } from '@opallabs/wormhole'
import { CurrentUserAvatar } from './CurrentUserAvatar'

const mapStateToProps = (state) => ({
  currentUser: selectors.selectMe(state),
  avatarUuid: selectors.selectCurrentUserAvatarUuid(state),
})

const mapDispatchToProps = (dispatch) => ({
  getMe: () => dispatch(actions.getMe()),
})

export const ConnectedCurrentUserAvatar = connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrentUserAvatar)
